var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('the-german',{attrs:{"value":_vm.de}}),_c('the-english',{attrs:{"value":_vm.en}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }